import { Box, Text } from '@bechtel/gds';
import Portal from '@reach/portal';
import { EllipsisSpinner } from '~/components/ellipsis-spinner';
import { BackdropStyled, CenterElementStyled } from './styled';

export const Backdrop = () => {
  return (
    <Portal>
      <BackdropStyled>
        <CenterElementStyled>
          <EllipsisSpinner></EllipsisSpinner>
          <Box>
            <Text color="grey.1000" weight="600" size="500">
              Please wait...
            </Text>
          </Box>
        </CenterElementStyled>
      </BackdropStyled>
    </Portal>
  );
};
